import { formatDate } from './format';
export const getDateByObject = ({
  date,
  format = 'yyyy/MM/dd',
  requiredReplaceSeparator,
}: {
  date: Date | string | null | undefined;
  format?: string;
  requiredReplaceSeparator?: boolean;
}) => {
  if (!date) return null;
  if (date instanceof Object) return formatDate(new Date(date), format);
  if (typeof date === 'string' && requiredReplaceSeparator)
    return `${date}`.replaceAll('-', '/');
  return date || null;
};
